/**
 * @author ankit.mishra
 * @Date: 2024-07-25 15:20:07
 * @Last Modified by: ankit
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  SET_YESBANK_ZINGER_CARDS_FAQ,
} from './constants';

const initialState = fromJS({
  isLoading: false,
  yesBankZingerCardsFaq: { status: false },
});

function yesBankFaqs(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case SET_YESBANK_ZINGER_CARDS_FAQ:
      return state
        .set('yesBankZingerCardsFaq', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default yesBankFaqs;



// WEBPACK FOOTER //
// client/containers/YesBankFaQs/reducer.js